module.exports = __webpack_public_path__ + "img/48.c3cad009.jpg";